import { EventType, Schedule } from "../types";

export const weekdays = [
  { value: 1, label: "Mon" },
  { value: 2, label: "Tue" },
  { value: 3, label: "Wed" },
  { value: 4, label: "Thu" },
  { value: 5, label: "Fri" },
  { value: 6, label: "Sat" },
  { value: 0, label: "Sun" },
];

export const defaultSchedule: Schedule = {
  weekdays: [1, 2, 3, 4, 5, 6, 0],
  startTime: "09:00",
  endTime: "18:00",
  slotInterval: 30,
  weeklyHours: {
    "0": { open: true, startTime: "10:00", endTime: "22:00" },
    "1": { open: true, startTime: "12:00", endTime: "22:00" },
    "2": { open: true, startTime: "12:00", endTime: "22:00" },
    "3": { open: true, startTime: "12:00", endTime: "22:00" },
    "4": { open: true, startTime: "12:00", endTime: "22:00" },
    "5": { open: true, startTime: "12:00", endTime: "22:00" },
    "6": { open: true, startTime: "10:00", endTime: "22:00" },
  },
  closedDates: [],
  dateOverrides: {},
  blockedSlots: {},
};

export const timeOptions = Array.from({ length: 24 * 6 }, (_, index) => {
  const hour = Math.floor(index / 6);
  const minute = (index % 6) * 10;
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
});

export const blankEvent: Partial<EventType> = {
  title: "",
  color: "#006bff",
  durationMinutes: 30,
  price: 0,
  meetingType: "In-person meeting",
  kind: "One-on-One",
  category: "regular",
  enabled: true,
  description: "",
  schedule: defaultSchedule,
};
